import { useEffect } from 'react'
import PostView from '../components/post-view'
import { fetchPosts, maybeFetchPosts } from '../actions'
import { FEATURED_POSTS_COLLECTION_SLUG } from '../constants'
import { useDispatch, useSelector } from 'react-redux'

import {
  getNextPost,
  getPostsByIds,
  getPostsBySlugs,
  getPreviousPost,
} from '../reducers'

const MIN_RELATED_POSTS_COUNT = 3
const POPULAR_POSTS_COUNT = 5

interface PostProps {
  emailUrls: string[]
  minimalView: boolean
  params: {
    slug: string
  }
  previewPost?: Post
}

const Post = ({ emailUrls, minimalView, params, previewPost }: PostProps) => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state as any)

  const getState = () => state // this is a temporary adapter for the actions

  const postSlug = params.slug
  const post =
    previewPost || state.posts[postSlug] || Object.values(state.posts)[0]

  const nextPost = () => getNextPost(state, post)
  const previousPost = () => getPreviousPost(state, post)

  const popularPosts = () =>
    getPostsBySlugs(
      state.collections[FEATURED_POSTS_COLLECTION_SLUG].itemIds.filter(
        (slug: string) => slug != post.slug
      ),
      state
    )

  const relatedPosts = () => {
    let related = getPostsByIds(post.relatedPostIds, state)

    if (related.length < MIN_RELATED_POSTS_COUNT) {
      const popularPostsNotOnPage = popularPosts().slice(
        POPULAR_POSTS_COUNT,
        POPULAR_POSTS_COUNT + (MIN_RELATED_POSTS_COUNT - relatedPosts.length)
      )
      related = related.concat(popularPostsNotOnPage)
    }

    if (relatedPosts.length < MIN_RELATED_POSTS_COUNT) {
      const topPopularPosts = popularPosts().slice(
        0,
        MIN_RELATED_POSTS_COUNT - relatedPosts.length
      )
      related = related.concat(topPopularPosts)
    }

    return related
  }

  useEffect(() => {
    if (Object.keys(state.posts).length === 1) {
      fetchPosts({ excludeBody: true })(dispatch, getState)
    }

    maybeFetchPosts([postSlug], 'slug')(dispatch, getState)
  }, [post])

  return post ? (
    <PostView
      post={post}
      relatedPosts={relatedPosts()}
      nextPost={nextPost()}
      previousPost={previousPost()}
      emailUrls={emailUrls}
      minimalView={minimalView}
    />
  ) : null
}

export default Post
